import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const AES_IV = CryptoJS.enc.Hex.parse("417265796F756D79536E6F776D616E3F");

function normalizeHex(value) {
  return String(value || "").replace(/\s/g, "");
}

function padExponentHex(hex) {
  let value = normalizeHex(hex);
  if (value.length % 2 === 1) {
    value = "0" + value;
  }
  if (value.length < 6) {
    value = value.padStart(6, "0");
  }
  return value.toUpperCase();
}

function padModulusHex(hex) {
  let value = normalizeHex(hex);
  if (value.length % 2 === 1) {
    value = "0" + value;
  }
  if (value.length < 256) {
    value = value.padStart(256, "0");
  }
  return value.toUpperCase();
}

function extractAesKey(rawKey) {
  const cleaned = String(rawKey || "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .trim();
  if (/^[0-9a-fA-F]{32}$/.test(cleaned)) {
    return cleaned;
  }
  return "";
}

function normalizeAesKey(key) {
  const result = extractAesKey(key);
  if (!result) {
    return "";
  }
  return result;
}

function aesDecrypt(ciphertext, password) {
  if (!ciphertext) {
    return "";
  }
  const aesKey = normalizeAesKey(password);
  if (!aesKey) {
    throw new Error("RSA解密失败");
  }
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(String(ciphertext).trim()) },
    key,
    {
      iv: AES_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  try {
    const plainText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!plainText) {
      throw new Error("题干解密失败");
    }
    return plainText;
  } catch (error) {
    throw new Error("题干解密失败");
  }
}

function rsaDecryptAesKey(encryptedKey, crypt) {
  if (!encryptedKey) {
    return "";
  }
  const cipherText = String(encryptedKey).trim();
  let rawKey = crypt.decrypt(cipherText);
  if (!rawKey && /^[0-9a-fA-F]+$/.test(cipherText.replace(/\s/g, ""))) {
    rawKey = crypt.getKey().decrypt(normalizeHex(cipherText));
  }
  return extractAesKey(rawKey);
}

function decryptQuestionList(questionList, aesKey) {
  return questionList.map((item) => {
    const question = Object.assign({}, item);
    if (question.QuestionContent) {
      question.QuestionContent = aesDecrypt(question.QuestionContent, aesKey);
    }
    return question;
  });
}

export function createQuestionRsaSession() {
  const crypt = new JSEncrypt({ default_key_size: 1024 });
  const key = crypt.getKey();
  if (!key) {
    throw new Error("RSA密钥生成失败");
  }
  return {
    clientPublic1: padExponentHex(key.e.toString(16)),
    clientPublic2: padModulusHex(key.n.toString(16)),
    crypt: crypt,
  };
}

export function buildExamDataFromResponse(payload, rsaSession) {
  if (!payload || !rsaSession || !rsaSession.crypt) {
    throw new Error("试题解密参数无效");
  }
  const encryptedKey = payload.EncryptedKey || payload.encryptedKey;
  if (!encryptedKey) {
    throw new Error("试题解密参数无效");
  }
  if (!payload.QuestionList || !payload.QuestionList.length) {
    throw new Error("试题数据异常");
  }
  const aesKey = rsaDecryptAesKey(encryptedKey, rsaSession.crypt);
  if (!aesKey || aesKey.length !== 32) {
    throw new Error("RSA解密失败");
  }
  const examData = Object.assign({}, payload);
  delete examData.EncryptedKey;
  delete examData.encryptedKey;
  examData.QuestionList = decryptQuestionList(payload.QuestionList, aesKey);
  return examData;
}

export function buildH5QuestionListFromResponse(payload, rsaSession) {
  if (!payload || !rsaSession || !rsaSession.crypt) {
    throw new Error("试题解密参数无效");
  }
  const encryptedKey = payload.EncryptedKey || payload.encryptedKey;
  if (!encryptedKey) {
    throw new Error("试题解密参数无效");
  }
  const questionList = payload.QuestionList;
  if (!questionList || !questionList.length) {
    throw new Error("试题数据异常");
  }
  const aesKey = rsaDecryptAesKey(encryptedKey, rsaSession.crypt);
  if (!aesKey || aesKey.length !== 32) {
    throw new Error("RSA解密失败");
  }
  return decryptQuestionList(questionList, aesKey);
}



// WEBPACK FOOTER //
// ./src/utils/questionCrypto.js